"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.986 4.831a1.556 1.556 0 0 0-2.15 0 1.405 1.405 0 0 0 0 2.034 1.556 1.556 0 0 0 2.15 0c.58-.564.58-1.47 0-2.034ZM3.86 3.827a2.956 2.956 0 0 1 4.101 0 2.804 2.804 0 0 1 .428 3.515l2.584 1.804 4.926-3.439a.7.7 0 0 1 .802 1.148L12.196 10l4.505 3.145a.7.7 0 0 1-.802 1.148l-4.926-3.44-2.584 1.805a2.804 2.804 0 0 1-.428 3.515 2.956 2.956 0 0 1-4.101 0 2.805 2.805 0 0 1 0-4.042 2.96 2.96 0 0 1 3.49-.455L9.75 10l-2.4-1.676a2.96 2.96 0 0 1-3.49-.455 2.805 2.805 0 0 1 0-4.042Zm3.126 9.308a1.556 1.556 0 0 0-2.15 0 1.405 1.405 0 0 0 0 2.034 1.556 1.556 0 0 0 2.15 0c.58-.564.58-1.47 0-2.034Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=CutIcon20.js.map